<template>
	<div v-if="aiWeShow">
		<div class="fadein_bind WE">
			<div class="box" style="width: 840px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencixiezuo')}}</p>
						<div class="contents on">{{aiData.text}}</div>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="total">
							<div class="frs" style="padding-left: 20px;">
								<div class="jds">
									<div class="icon">
										<span>{{$t('neirong')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('nr')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.content/aiData.contentTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.content}}<i>/{{aiData.contentTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('geshi')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('gs')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.form/aiData.formTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.form}}<i>/{{aiData.formTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('yufa')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('yf')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.grammar/aiData.grammarTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.grammar}}<i>/{{aiData.grammarTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('pinxie')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('px')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.spelling/aiData.spellingTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.spelling}}<i>/{{aiData.spellingTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('cihuifw')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('chfw')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.vocabulary/aiData.vocabularyTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.vocabulary}}<i>/{{aiData.vocabularyTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('yuyanfw')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('yyfw')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.generalLinguisticRange/aiData.generalLinguisticRangeTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.generalLinguisticRange}}<i>/{{aiData.generalLinguisticRangeTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('jiegoulj')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('jg')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.structureAndCoherence/aiData.structureAndCoherenceTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.structureAndCoherence}}<i>/{{aiData.structureAndCoherenceTotal}}</i></em></span>
								</div>
							</div>
						</div>
					</div>
					<div class="item" v-if="aiData.sentsFeedbacks.length">
						<div class="h">
							<p>{{$t('zhinengjc')}}</p>
						</div>
						<div class="jcs">
							<div class="lab" v-for="(item, index) in aiData.sentsFeedbacks">
								<p>{{$t('yuanju')}}:{{item.rawSent}}</p>
								<p>{{$t('zqjuzi')}}:{{item.correctedSent}}</p>
								<em v-for="(items, indexs) in item.errorPosInfos">{{$t('cwyuanyin')}}：{{items.errBaseInfo}}；{{$t('cwneirong')}}：{{items.orgChunk}}</em>
							</div>
						</div>
					</div>
					<div class="button" style="margin-top: 28px;">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
					</div>
				</div>
			</div>
		</div>
		<AiDesc :descFont="descFont"></AiDesc>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'aiweShow',
		props: ['aiData'],
		data() {
			return {
showbox: true,
				descFont: {}
			}
		},
		computed: {
			aiWeShow() {
				return this.$store.state.aiWeShow;
			}
		},
		methods: {
			showDesc(type){
				if(type == 'nr'){
					this.descFont = {
						title: '内容',
						desc: `6 - The essay fully addresses the prompt in depth, demonstrating full command of the argument by reformulating the issue seamlessly in own words and expanding on important points with specificity. The argument is supported convincingly with subsidiary points and relevant examples throughout the response.
						</br>5 - The essay adequately addresses the prompt, presenting a persuasive argument with relevant ideas. Main points are highlighted,and relevant supporting detail is given to support the response effectively, with minor exceptions.
						</br>4 - The essay adequately addresses the main point of the prompt. The argument is generally convincing, though lacks depth or nuance. Supporting detail is inconsistent throughout the response. It is present for some points but weaker or missing for others.
						</br>3 - The essay is relevant to the prompt but does not address the main points adequately. Supporting detail is often missing or inappropriate.
						</br>2 - The essay attempts to address the prompt, but does so superficially, with little relevant information and largely generic statements or over reliance on repeating language from the prompt. Few supporting details are included. Ideas that are present lack relevance, with only tangential links to the topic.
						</br>1 - The essay attempts to address the prompt, but demonstrates an incomplete understanding of the prompt with communication limited to generic or repetitive phrasing, or repeating language from the prompt. Supporting details, if present, are used in a disjointed or haphazard manner, with no clear links to the topic.
						</br>0 - The essay does not properly deal with the prompt.
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>写作时一定要 紧扣题意 (prompt) —— 回答题中所有要求的问题，不偏题也不遗漏重要方面。只有“内容对题 + 涵盖必要要点”才能得满分。如果题目要求讨论多个方面／观点 (例如优缺点、利与弊、两种观点对比等)，确保都有所涉及。哪怕只缺少一个重要点，也会扣分。Write Essay 已加入人工审核，对内容的要求已较之前有显著提高。需要紧扣题目，写出言之有物的内容，不要用过多的与主题无关的内容。 `
					}
				}
				else if(type == 'gs'){
					this.descFont = {
						title: '格式',
						desc: `2 Length is between 200 and 300 words
						</br>1 Length is between 120 and 199 or between 301 and 380 words
						</br>0 Length is less than 120 or more than 380 words. Essay is written in capital letters, contains no punctuation or only consists of bullet points or very short sentences
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>在 WE 中，“Form”（格式/形式）部分很关键。若格式不正确，即使内容正确，也可能被扣分或得零分。根据官方/主流辅导资料，格式是一定要拿下的送分部分，只要字数达到要求就会有 2 分。即使你仅仅是把一段话复制粘贴，也会有这 2 分。 `
					}
				}
				else if(type == 'yf'){
					this.descFont = {
						title: '语法',
						desc: `2 Shows consistent grammatical control of complex language. Errors are rare and difficult to spot
						</br>1 Shows a relatively high degree of grammatical control. No mistakes which would lead to misunderstandings
						</br>0 Contains mainly simple structures and/or several basic mistakes
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>尽量使用正确、语法结构完整的句子 — 包括主语／谓语／宾语、从句、复合句等。语法错误越少，得分越高。注意基础语法要点：动词时态、主谓一致、标点、连接词、从句结构等。不要为了“复杂”而牺牲准确性。`
					}
				}
				else if(type == 'px'){
					this.descFont = {
						title: '语法',
						desc: `2 Correct spelling
						</br>1 One spelling error
						</br>0 More than one spelling error
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>注意拼写 (spelling)、标点 (punctuation) 和一致性 (例如美式 / 英式拼写风格) — 拼写错误或标点混乱会导致扣分。 其中单词的正确拼写非常重要，一个拼写错误就扣 1 分，一定要仔细检查。`
					}
				}
				else if(type == 'chfw'){
					this.descFont = {
						title: '词汇范围',
						desc: `2 Good command of a broad lexical repertoire, idiomatic expressions and colloquialisms
						</br>1 Shows a good range of vocabulary for matters connected to general academic topics. Lexical shortcomings lead to circumlocution or some imprecision
						</br>0 Contains mainly basic vocabulary insufficient to deal with the topic at the required level
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>使用多样、准确、学术性 (formal / academic English) 的词汇 — 避免过于口语化或简单重复。展现良好的词汇范围和语言控制，会帮你在这一维度拿高分。`
					}
				}
				else if(type == 'yyfw'){
					this.descFont = {
						title: '语言表达范围',
						desc: `6 A variety of expressions and vocabulary are used appropriately to formulate ideas with ease and precision throughout the response. No signs of limitations restricting what can be communicated. Errors in language use, if present, are rare and minor, and meaning incompletely clear.
						</br>5 A variety of expressions and vocabulary are used appropriately throughout the response. Ideas are expressed clearly without much sign of restriction. Occasional errors in language use are present, but the meaning is clear.
						</br>4 The range of expression and vocabulary is sufficient to articulate basic ideas. Most ideas are clear, but limitations are evident when conveying complex / abstract ideas, causing repetition, circumlocution, and difficulty with formulation at times. Errors in language use cause occasional lapses in clarity, but the main idea can still be followed.
						</br>3 The range of expression and vocabulary is narrow and simple expressions are used repeatedly. Communication is restricted to simple ideas that can be articulated through basic language. Errors in language use cause some disruptions for the reader.
						</br>2 Limited vocabulary and simple expressions dominate the response. Communication is compromised and some ideas are unclear. Basic errors in language use are common, causing frequent breakdowns and misunderstanding.
						</br>1 Vocabulary and linguistic expression are highly restricted. There are significant limitations in communication and ideas are generally unclear. Errors in language use are pervasive and impede meaning.
						</br>0 Meaning is not accessible.
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>采用丰富的句式和表达，复杂和简单句式可以交替使用`
					}
				}
				else if(type == 'jg'){
					this.descFont = {
						title: '发展/结构/连贯性',
						desc: `6 The essay has an effective logical structure, flows smoothly, and can be followed with ease. An argument is clear and cohesive, developed systematically at length. A well-developed introduction and conclusion are present. Ideas are organised cohesively into paragraphs, and paragraphs are clear and logically sequenced. The essay uses a variety of connective devices effectively and consistently to convey relationships between ideas.
						</br>5 The essay has a conventional and appropriate structure that follows logically, if not always smoothly. An argument is clear, with some points developed at length. Introduction, conclusion and logical paragraphs are present. The essay uses connective devices to link utterances into clear, coherent discourse, though there may be some gaps or abrupt transitions between one idea to the next.
						</br>4 Conventional structure is mostly present, but some elements may be missing, requiring some effort to follow. An argument is present but lacks development of some elements or may be difficult to follow. Simple paragraph breaks are present, but they are not always effective, and some elements or paragraphs are poorly linked. The ideas in the response are not well connected. The lack of connection might come from an ordering of the ideas which is difficult to grasp, or a lack of language establishing coherence among ideas.
						</br>3 Traces of the conventional structure are present, but the essay is composed of simple points or disconnected ideas. A position/opinion is present, although it is not sufficiently developed into a logical argument and often lacks clarity. Essay does not make effective use of paragraphs or lacks paragraphs but presents ideas with some coherence and logical sequencing. The response consists mainly of unconnected ideas, with little organizational structure evident, and requires significant effort to follow. The most frequently occurring connective devices link simple sentences and larger elements linearly, but more complex relationships are not expressed clearly or appropriately.
						</br>2 There is little recognisable structure. Ideas are presented in a disorganised manner and are difficult to follow. A position/opinion may be present but lacks development or clarity. The essay lacks coherence, and mainly consists of disconnected elements. Can link groups of words with simple connective devices (e.g., "and", "but" and "because").
						</br>1 Response consists of disconnected ideas. There is no hierarchy of ideas or coherence among points. No clear position/opinion can be identified. Words and short statements are linked with very basic linear connective devices(e.g., "and" or "then").
						</br>0 There is no recognisable structure.
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>在 PTE 写作中，Development, Structure and Coherence 要求文章结构清晰、逻辑连贯、观点充分展开。一篇高分作文通常包含引言、2–3 段正文和结论，每段只讨论一个主要论点，并用解释或例子支撑。段落与句子之间需用连接词平滑过渡，保持整体逻辑顺序（例如背景 → 论证 → 结论）。避免观点堆砌或无条理罗列，写完后快速自查段落过渡、论点展开和逻辑流畅性，以确保文章思路清晰、连贯自然。`
					}
				}
				this.$store.commit("showaiDESCShow", true);
			},
			back() {
				this.$store.commit("showaiWeShow", false);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ai-we.vue